import { render, staticRenderFns } from "./item_list.vue?vue&type=template&id=0a6ec8ee&scoped=true"
import script from "./item_list.vue?vue&type=script&lang=js"
export * from "./item_list.vue?vue&type=script&lang=js"
import style0 from "./item_list.vue?vue&type=style&index=0&id=0a6ec8ee&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a6ec8ee",
  null
  
)

export default component.exports